import { faEnvelope, faLock } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { useQueryClient } from '@tanstack/react-query'
import { useFormik } from 'formik'
import React, { useState } from 'react'
import { Form, InputGroup } from 'react-bootstrap'

import { Link, useNavigate } from 'react-router-dom'

import { toast } from 'react-toastify'
import * as Yup from 'yup'
import Button from '../../components/Button'
import { authLogin } from '../../services/auth.service'
import { setWindowClass } from '../../util/helpers'

function Login() {
  const [isAuthLoading, setAuthLoading] = useState(false)

  const navigate = useNavigate()
  const queryClient = useQueryClient()

  const login = async (email: string, password: string): Promise<void> => {
    try {
      setAuthLoading(true)
      const token = await authLogin(email, password)
      toast.success('Login is succesvol!')
      setAuthLoading(false)
      queryClient.invalidateQueries({
        queryKey: ['user'],
      })
      navigate('/')
    }
    catch (error: any) {
      setAuthLoading(false)

      switch (error.response?.status) {
        case 401:
          toast.error('Ongeldige gebruikersnaam of wachtwoord')
          break
        case 403:
          toast.error(error.response?.data.message)
          break
        default:
          toast.error('Er is een fout opgetreden')
          break
      }
    }
  }

  const { handleChange, values, handleSubmit, touched, errors } = useFormik({
    initialValues: {
      email: '',
      password: '',
    },
    validationSchema: Yup.object({
      email: Yup.string().email('Invalid email address').required('Required'),
      password: Yup.string()
        .min(5, 'Must be 5 characters or more')
        .max(30, 'Must be 30 characters or less')
        .required('Required'),
    }),
    onSubmit: (values) => {
      login(values.email, values.password)
    },
  })

  setWindowClass('hold-transition login-page bg-body-secondary')

  return (
    <div className="login-box">
      {/*
      <Snowfall
        snowflakeCount={250}
      /> */}
      {/* <Fireworks
        options={{
          rocketsPoint: {
            min: 0,
            max: 100
          }
        }}
        style={{
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          position: 'fixed',
          pointerEvents: 'none',
        }}
      /> */}

      <div className="card card-outline card-primary">
        <div className="card-header text-center">
          <Link to="/" className="h2">
            <b>DATAFIBER</b>
            <span>NETWORK</span>
          </Link>
        </div>
        <div className="card-body">
          <p className="login-box-msg">Inloggen</p>
          <form onSubmit={handleSubmit}>
            <div className="mb-3">
              <InputGroup className="mb-3">
                <Form.Control
                  id="email"
                  name="email"
                  type="email"
                  placeholder="Email"
                  onChange={handleChange}
                  value={values.email}
                  isValid={touched.email && !errors.email}
                  isInvalid={touched.email && !!errors.email}
                />
                {touched.email && errors.email
                  ? (
                      <Form.Control.Feedback type="invalid">
                        {errors.email}
                      </Form.Control.Feedback>
                    )
                  : (
                      <InputGroup.Text>
                        <FontAwesomeIcon icon={faEnvelope} />
                      </InputGroup.Text>
                    )}
              </InputGroup>
            </div>
            <div className="mb-3">
              <InputGroup className="mb-3">
                <Form.Control
                  id="password"
                  name="password"
                  type="password"
                  placeholder="Password"
                  onChange={handleChange}
                  value={values.password}
                  isValid={touched.password && !errors.password}
                  isInvalid={touched.password && !!errors.password}
                />
                {touched.password && errors.password
                  ? (
                      <Form.Control.Feedback type="invalid">
                        {errors.password}
                      </Form.Control.Feedback>
                    )
                  : (
                      <InputGroup.Text>
                        <FontAwesomeIcon icon={faLock} />
                      </InputGroup.Text>
                    )}
              </InputGroup>
            </div>

            <div className="row">
              <div className="col-4 offset-8">
                <Button type="submit" isLoading={isAuthLoading} block className="test">
                  Login
                </Button>
              </div>
            </div>
          </form>
          <p className="mb-1">
            <Link to="/forgot-password">Wachtwoord Vergeten</Link>
          </p>
        </div>
      </div>

    </div>
  )
}

export default Login
